<template>
  <div class="listOne" v-show="newList.length>0">
    <div v-for="(item, index) in newList" :key="index" class="box-list clearfix" @click="shoDetial(item)">
      <div class="box-list-img fl">
        <img :src="item.title_img_path" />
      </div>
      <div class="box-list-font fl">
        <div class="title">{{ item.dynamic_data.name }}</div>
        <div class="info">合作导师：{{ item.dynamic_data.supervisor }}</div>
        <div class="info">研究方向：{{ item.dynamic_data.direction }}</div>
        <div class="info">Email: {{ item.dynamic_data.mailbox }}</div>
      </div>
    </div>
    <div class="page">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    columnId: {
      type: String,
      default: '',

    }
  },
  data() {
    return {
      newList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: self.columnId,
        pageNo: self.currentPage,
        pageCount: self.pageSize
      },
        function (res) {
          if (res.code == '000000') {
            self.newList = res.data.data || []
            self.total = res.data.count
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    handleSizeChange() {

    },
    handleCurrentChange(item) {
      this.currentPage = item
      this.getList()
    },
    shoDetial(item) {
      this.$emit('detail', item)
    }
  },
  watch: { // 监听，当路由发生变化的时候执行

  }
};
</script>

<style lang="less" scoped>
.listOne {
  .box-list {
    // width: 800px;
    margin: 20px auto;
    height: 210px;
    box-sizing: border-box;
    padding: 10px;
    cursor: pointer;

    .box-list-img {
      width: 100px;
      height: 133px;
      margin-right: 20px;

      img {
        width: 100px;
        height: 133px;
      }

    }

    .box-list-font {
      width: 450px;
      height: 200px;
      

      .title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
        color: rgb(31, 73, 125);
      }

      .info {
        font-size: 16px;
        color: #000000;
        margin-bottom: 10px;
      }
    }
  }

  .page {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>